import { Action } from '../Action/index.js';
import Palette from '../theme/shared/palette.js';
import * as React from 'react';
import { useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';
import { CircleAttentionIcon, CircleTickIcon } from './styles.js';
import { AccountOutlineIcon } from '../Icons/components/AccountOutline.js';

const TopSection = ({ actionProps , userName , accountEmail , isAccountVerified , isAccountIncomplete , profileButtonText  })=>{
    const theme = useContext(ThemeContext);
    const circleBadgeProps = useMemo(()=>{
        if (isAccountIncomplete) {
            return {
                hasCircleBadge: true,
                circleBadgeColor: theme.colors.ElementBackground,
                circleBadgeIcon: /*#__PURE__*/ React.createElement(CircleAttentionIcon, {
                    size: 20,
                    color: theme.colors.caution
                }),
                circleBorderColor: Palette.yolk[50]
            };
        }
        if (isAccountVerified) {
            return {
                hasCircleBadge: true,
                circleBadgeColor: theme.colors.ElementBackground,
                circleBadgeIcon: /*#__PURE__*/ React.createElement(CircleTickIcon, {
                    size: 20,
                    color: theme.colors.positive
                }),
                circleBorderColor: Palette.broccoli[25]
            };
        }
        return undefined;
    }, [
        isAccountVerified,
        isAccountIncomplete
    ]);
    return /*#__PURE__*/ React.createElement(Action, {
        ...actionProps,
        ...circleBadgeProps,
        icon: /*#__PURE__*/ React.createElement(AccountOutlineIcon, {
            color: theme.colors.secondary
        }),
        title: userName,
        description: accountEmail,
        hasAdditionalButton: true,
        additionalButtonText: profileButtonText
    });
};

export { TopSection };
